/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Such_Sound_Giraffe_DustInputs */

const fr_such_sound_giraffe_dust = /** @type {(inputs: Such_Sound_Giraffe_DustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors de l'upload`)
};

/**

* @param {Such_Sound_Giraffe_DustInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const such_sound_giraffe_dust = /** @type {((inputs?: Such_Sound_Giraffe_DustInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Such_Sound_Giraffe_DustInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_such_sound_giraffe_dust(inputs)
});